const prefix = (type) => `eureka/generator/${type}`;

export const SAVING_START = prefix('SAVING_START');
export const SAVING_SUCCESS = prefix('SAVING_SUCCESS');
export const SAVING_FAILED = prefix('SAVING_FAILED');

export const CLEAR_STATE = prefix('CLEAR_STATE');
export const CLEAR_PROGRESS = prefix('CLEAR_PROGRESS');
